"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountStatusEnum = void 0;
var AccountStatusEnum;
(function (AccountStatusEnum) {
    AccountStatusEnum["ACTIVE"] = "Active";
    AccountStatusEnum["BEGINNER_ONBOARDING"] = "Beginner onboarding";
    AccountStatusEnum["REPEATED_ONBOARDING"] = "Repeated onboarding";
    AccountStatusEnum["DEACTIVATED"] = "Deactivated";
    AccountStatusEnum["DOCUMENTS_PENDING"] = "Documents pending";
    AccountStatusEnum["NEW"] = "New";
    AccountStatusEnum["NOT_INTERESTED"] = "Not interested";
    AccountStatusEnum["NOT_QUALIFIED"] = "Not Qualified";
    AccountStatusEnum["RESTRICTED"] = "Restricted";
    AccountStatusEnum["SUSPENDED"] = "Suspended";
})(AccountStatusEnum = exports.AccountStatusEnum || (exports.AccountStatusEnum = {}));
//# sourceMappingURL=account-status-enum.js.map